export default __webpack_public_path__ + "static/media/avatar.916f39d3.jpg";